import { List } from 'immutable';
import { computed, makeAutoObservable } from 'mobx';

export class WithdrawProcedureState {
    constructor(private readonly permissionGrants: List<any>) {
        makeAutoObservable(this);
    }

    @computed get hasWithdrawalsPermission(): boolean {
        if (this.permissionGrants && this.permissionGrants.size) {
            for (let i = 0; i < this.permissionGrants.size; i++) {
                if (this.permissionGrants.getIn([i, 'permission']) === 'banking/withdrawals') {
                    return true;
                }
            }
        }
        return false;
    }
}
